import Vue from 'vue'
import IEUserAgent from './detect'
import _throttle from 'lodash/throttle'

export const EventBus = new Vue({
    data() {
        return {
           pageLoaded: false
        }
    },
    computed: {
        ieUserAgent() {
            return IEUserAgent.getVersion()
        },
        compatibilityMode() {
            return this.ieUserAgent.compatibilityMode && this.ieUserAgent.version < 11
        }
    },
    methods: {
        setPageLoaded(loaded) {
            this.pageLoaded = loaded
        }
    }
});